<div id="main-report-map" leaflet *ngIf="!!mapOptions" class="map" [leafletOptions]="mapOptions"
    (leafletMapReady)="onMapReady($event)" [(leafletCenter)]="mapCenter">
</div>